import { Share, PlusSquare, MoreVertical, Smartphone, CheckCircle2 } from "lucide-react";
import AppHeader from "@/components/layout/AppHeader";

const Paso = ({ n, icon: Icon, children }) => (
  <li className="flex gap-3 items-start">
    <span className="w-7 h-7 rounded-full bg-[#1F3354] text-white text-sm font-bold flex items-center justify-center shrink-0">{n}</span>
    <span className="text-slate-700 text-sm sm:text-base pt-0.5">{children} {Icon && <Icon className="inline w-4 h-4 text-[#1F3354] -mt-0.5" />}</span>
  </li>
);

const Tarjeta = ({ titulo, testid, children }) => (
  <section className="bm-card p-5 sm:p-6" data-testid={testid}>
    <h2 className="font-heading font-bold text-lg text-slate-900 mb-4">{titulo}</h2>
    <ol className="space-y-3">{children}</ol>
  </section>
);

export default function InstalarPage() {
  const instalada = window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone;
  return (
    <div className="min-h-screen">
      <AppHeader />
      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-8 sm:py-12" data-testid="instalar-page">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#EDF5F3] text-[#1F4640] text-xs font-bold uppercase tracking-widest">
          <Smartphone className="w-3.5 h-3.5" /> En tu pantalla de inicio
        </div>
        <h1 className="mt-3 font-heading text-3xl sm:text-4xl font-extrabold text-slate-900">Instala Co-Legal en tu celular</h1>
        <p className="mt-2 text-slate-600">Ábrela como una app, sin barra del navegador. No necesitas tienda de apps.</p>
        {instalada && (
          <p className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-[#047857]" data-testid="instalar-ya-instalada">
            <CheckCircle2 className="w-4 h-4" /> Ya la estás usando instalada.
          </p>
        )}
        <div className="mt-8 grid gap-5 sm:grid-cols-2">
          <Tarjeta titulo="iPhone" testid="instalar-iphone">
            <Paso n={1}>Abre <b>co-legal.app</b> en <b>Safari</b>.</Paso>
            <Paso n={2} icon={Share}>Toca <b>Compartir</b></Paso>
            <Paso n={3} icon={PlusSquare}>Elige <b>Agregar a inicio</b></Paso>
            <Paso n={4}>Toca <b>Agregar</b>. Abre Co-Legal desde su ícono.</Paso>
          </Tarjeta>
          <Tarjeta titulo="Android" testid="instalar-android">
            <Paso n={1}>Abre <b>co-legal.app</b> en <b>Chrome</b>.</Paso>
            <Paso n={2} icon={MoreVertical}>Toca el menú <b>⋮</b></Paso>
            <Paso n={3}>Elige <b>Instalar app</b> o <b>Agregar a pantalla principal</b>.</Paso>
            <Paso n={4}>Confirma. Abre Co-Legal desde su ícono.</Paso>
          </Tarjeta>
        </div>
        <p className="mt-6 text-xs text-slate-500">Tus documentos y datos de personas no se guardan en el celular: siempre se consultan en línea.</p>
      </main>
    </div>
  );
}
